import React from 'react';
import { connect } from 'react-redux';
import { options } from 'config/reactRedux';
import { getEdition } from 'selectors/getEdition';
import withStyles from 'isomorphic-style-loader/withStyles';
import SearchForm from 'components/searchForm';
import I18n from 'components/i18n';
import CallToAction from 'components/callToAction';
import NavExplore from 'components/nav/navExplore';
import { buildCTALink } from 'utils/url';
import { LANGUAGES } from 'config/types/prop';

import styles from './menuNav.css';

const MenuNav = ({ currentEdition }) => {
  const goLink = buildCTALink(currentEdition);
  const ctaLabel = <I18n field="try-babbel" defaultText="Try Babbel" />;

  return (
    <div className={styles.wrapper}>
      <div className={styles.headerCTAWrapper}>
        <div className={styles.heading}>
          <I18n
            field="which-language-do-you-want-to-learn"
            defaultText="Speak a new langauge with confidence"
          />
        </div>
        <div className={styles.ctaContainer}>
          <CallToAction
            isInHeader
            text={ctaLabel}
            url={goLink}
          />
        </div>
      </div>
      <div className={styles.searchFormWrapper}>
        <SearchForm />
      </div>
      <NavExplore />
    </div>
  );
};

MenuNav.propTypes = {
  currentEdition: LANGUAGES.isRequired,
};

const mapStateToProps = (state) => ({
  currentEdition: getEdition(state),
});

const withRedux = connect(
  mapStateToProps,
  undefined,
  undefined,
  options,
);

const wrapWithStyles = withStyles(styles);

export default wrapWithStyles(withRedux(MenuNav));
